// WHETHER THE PAGE RUNS AS THE INSTALLED APP (home screen, no browser bars) rather than in a browser
// tab. iOS answers through `navigator.standalone`, everything else through the display mode.
export function isStandalone(): boolean {
  return matchMedia('(display-mode: standalone)').matches
    || (navigator as { standalone?: boolean }).standalone === true;
}

// OPENING A PAGE FROM THE INSTALLED APP, AND LETTING THE APP GO (Louis 2026-10-26). A link followed
// there keeps the app's page alive behind the new one, for going back, and on an iPhone the two
// share one budget: the published tutorial, opened from Phase 8, was killed by iOS and loaded again,
// where alone in Safari it never was. So the app's page is REPLACED rather than left behind: coming
// back reloads it. For a link's onClick; anywhere else (a tab, a new tab) the link does as it says.
export function replaceIfStandalone(e: { preventDefault: () => void }, url: string) {
  if (!isStandalone()) return;
  e.preventDefault();
  window.location.replace(url);
}
